import { jsx as _jsx } from "react/jsx-runtime";
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { styled } from '../../system';
import { CloseButton } from '../CloseButton';
import { forwardRef } from 'react';
import { slideDownAndFadeKeyframes, slideLeftAndFadeKeyframes, slideRightAndFadeKeyframes, slideUpAndFadeKeyframes } from '../../keyframes';
import { wrapWithDefaultProps } from '../../lib/wrap-with-default-props';
export const popoverContentStyle = {
    minW: 220,
    bgColor: '$popoverBg',
    rounded: '$lg',
    shadow: '$lg',
    border: '1px solid $popoverBorder',
    overflow: 'hidden',
    zIndex: '$10',
    '@motionNoPreference': {
        animationDuration: '400ms',
        animationTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',
        willChange: 'transform, opacity',
        '&[data-state="open"]': {
            '&[data-side="top"]': { animationName: slideDownAndFadeKeyframes },
            '&[data-side="right"]': { animationName: slideLeftAndFadeKeyframes },
            '&[data-side="bottom"]': { animationName: slideUpAndFadeKeyframes },
            '&[data-side="left"]': { animationName: slideRightAndFadeKeyframes }
        }
    }
};
const StyledContent = styled(PopoverPrimitive.Content, {
    ...popoverContentStyle
});
const StyledCloseButton = styled(CloseButton, {
    position: 'absolute',
    top: 5,
    right: 5
});
export const PopoverContent = forwardRef(({ children, sideOffset = 8, ...props }, ref) => (_jsx(PopoverPrimitive.Portal, { children: _jsx(StyledContent, { ref: ref, sideOffset: sideOffset, ...props, children: children }) })));
export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = wrapWithDefaultProps(PopoverPrimitive.Trigger, {
    asChild: true
});
export const PopoverCloseButton = forwardRef((props, ref) => (_jsx(PopoverPrimitive.Close, { ref: ref, asChild: true, children: _jsx(StyledCloseButton, { autoFocus: false, size: "xs", circle: true, ...props }) })));
Popover.displayName = 'Popover';
PopoverContent.displayName = 'PopoverContent';
PopoverTrigger.displayName = 'PopoverTrigger';
PopoverCloseButton.displayName = 'PopoverCloseButton';
